<template>
    <div v-if="listItems.length > 0" class="hpo-counts__nationalities">
        <h4 class="hpo-counts__nationalities__title" @click="expanded = !expanded">
            <v-icon v-if="isMobile" :icon="isExpanded ? mdiChevronDown : mdiChevronRight"/>
            {{ pgettext('title', 'Nationalities') }}
        </h4>
        <div v-if="isExpanded" class="hpo-counts__nationalities__list">
            <v-tooltip v-for="item in listItems" :text="item.countryName" location="bottom">
                <template #activator="{ props }">
                    <v-chip color="light-blue-lighten-4" density="compact" variant="flat" :ripple="false" rounded
                            class="hpo-counts__nationalities__list-item" v-bind="props">
                        <img :src="staticUrl('svg/country-flags/' + item.countryCode.toLowerCase() + '.svg')"
                             class="hpo-counts__nationalities__flag mr-2"/>
                        <strong>{{ item.count }}</strong>
                    </v-chip>
                </template>
            </v-tooltip>
        </div>
    </div>
</template>

<script setup>
import {staticUrl} from "@/url";
import {isMobile} from "@/utils/breakpoints";
import {mdiChevronDown, mdiChevronRight} from "@mdi/js";
import {computed, ref} from "vue";

const props = defineProps({
    data: {
        type: Array,
        required: true,
        default: []
    }
});

const listItems = computed(() => {
    let items = []
    const intl = new Intl.DisplayNames(['cs'], {type: 'region'});
    for (const item of props.data) {
        items.push({
            countryName: intl.of(item.country),
            countryCode: item.country,
            count: item.count
        })
    }
    return items
});

const expanded = ref(false);

const isExpanded = computed(() => {
    return !isMobile.value || expanded.value;
});
</script>
